module.exports = __webpack_public_path__ + "static/media/logo.90632f4c.svg";